// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__3Mb6o","barra":"SearchBar_barra__3qWHd"};